import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { isUnreadNotification } from "web_myplann/NotificationCenter/Utils/isUnreadNotification";
import { parseNotificationData } from "web_myplann/NotificationCenter/Utils/parseNotificationData";

const isValidNotificationId = (id: number): boolean =>
	Number.isInteger(id) && id > 0;

const unique = (ids: number[]): number[] => Array.from(new Set(ids));

export const getTimelineNotificationIds = (
	item: TimelineItemResponseDTO,
): number[] => {
	if (item.category !== TimelineItemCategoryEnum.Notification) {
		return [];
	}
	if (item.isGroup && item.notificationIds && item.notificationIds.length > 0) {
		return unique(item.notificationIds.filter(isValidNotificationId));
	}
	const notificationId = parseNotificationData(item.data)?.notificationId;
	return notificationId !== undefined && isValidNotificationId(notificationId)
		? [notificationId]
		: [];
};

export const getNotificationIdsToMarkRead = (
	item: TimelineItemResponseDTO,
): number[] =>
	isUnreadNotification(item) ? getTimelineNotificationIds(item) : [];
